import { PagedMessageResponse } from "app/api/types/PagedMessageResponse";
import {
  FiltroListarProfissionais,
  ProfissionalComissoes,
} from "app/types/comissoes/Profissionais";
import clsx from "clsx";
import { useFormik } from "formik";
import * as R from "ramda";
import React, { useEffect, useState } from "react";
import { Paginacao } from "../../itens-orcamento/paginacao/Paginacao";

const estiloFormulario =
  require("../../../estilos/formulario.module.scss").default;
const estiloBotoes = require("../../../estilos/botoes.module.scss").default;

export type DadosAbaProfissionais = {
  abaProfissionaisFormulario: Partial<FiltroListarProfissionais>;
  listaPesquisa: Partial<PagedMessageResponse<ProfissionalComissoes>>;
  profissionaisSelecionados: ProfissionalComissoes[];
  listaProfissionaisTipo: {[codigo: number]: string}
}

export type AbaProfissionaisProps = {
  mostrarBotaoCancelar: boolean;
  colorBackgroundSelecionada: string;
  colorTextoSelecionada: string;
  somenteLeitura: boolean;
  onAlteradoDadosProfissionais: (dados: DadosAbaProfissionais) => void;
  onOk: (listarProfissionais: ProfissionalComissoes[], listaProfissionaisTipo: {[codigo: number]: string}) => void;
  onPesquisar: (abaProfissionaisFormulario: FiltroListarProfissionais) => void;
  onCancelar: () => void;
};

export const AbaProfissionais = (props: AbaProfissionaisProps & DadosAbaProfissionais) => {
  const [profissionaisSelecionados, setProfissionaisSelecionados] = useState<ProfissionalComissoes[]>(props.profissionaisSelecionados);
  const [listaProfissionaisTipo, setListaProfissionaisTipo] = useState<{[codigo: number]: string}>(props.listaProfissionaisTipo);
  
  const toggleProfissionaisSelecionada = (listarProfissionais: ProfissionalComissoes) => {
    if (profissionaisSelecionados.some((p) => p.Codigo == listarProfissionais.Codigo)) {
      setProfissionaisSelecionados(
        R.filter(
          (c) => c.Codigo != listarProfissionais.Codigo,
          profissionaisSelecionados
        )
      );
    } else {
      setProfissionaisSelecionados(
        profissionaisSelecionados.concat(listarProfissionais)
      );
    }
  };

  const acaoSubmit = (values) => {
    props.onPesquisar({...values, NumeroPagina: 1})
    Object.keys(listaProfissionaisTipo).forEach((i) => listaProfissionaisTipo[i] = "")
    setListaProfissionaisTipo(listaProfissionaisTipo)
    setProfissionaisSelecionados([])
  }  

  const formik = useFormik({
    initialValues: { ...props.abaProfissionaisFormulario },
    onSubmit: acaoSubmit,
    enableReinitialize: true,
  });  

  useEffect(() => {
    props.onAlteradoDadosProfissionais({
      abaProfissionaisFormulario: formik.values,
      listaPesquisa: props.listaPesquisa,
      profissionaisSelecionados,
      listaProfissionaisTipo}
    );
  }, [formik.values, props.listaPesquisa, profissionaisSelecionados, listaProfissionaisTipo]);

  const botaoOkListaProfissionais = (
    <>
      {props.listaPesquisa?.Entities?.length > 0 && (
        <button type="button"
          id="AbaProfissionais_BotaoOk"
          className={clsx(`no-global-button  !_bg-[#409fff] ${estiloBotoes.botaoPrimario}`)}
          onClick={() => props.onOk(profissionaisSelecionados, listaProfissionaisTipo)}
        >
          Ok
        </button>
      )}
    </>
  );  

  const formPesquisa = () => {
    const campoFiltroNomeProfissional = (
      <div
        className={`_ml-36 _pt-8 _items-baseline ${estiloFormulario.formulario}`}
      >
        <label>Nome</label>
        <input
          style={{ width: "440px" }}
          id="AbaProfissionais_CampoNome"
          name="Nome"
          value={(formik.values?.Nome) ?? ""}
          onChange={formik.handleChange}
          disabled={props.somenteLeitura}
        />
      </div>
    );

    const botaoPesquisarProfissionais = (
      <button type="submit" className={clsx(`no-global-button  !_bg-[#409fff] ${estiloBotoes.botaoPrimario}`)}
        id="AbaProfissionais_BotaoPesquisar"
      >
        Pesquisar
      </button>
    );
  
    const botaoCancelarListaProfissionais = (
      <>
        {props.mostrarBotaoCancelar && (
          <button type="button"
            className={clsx(`no-global-button  !_bg-[#409fff] ${estiloBotoes.botaoPrimario}`)}
            id="AbaProfissionais_BotaoCancelar"
            onClick={() => props.onCancelar()}
          >
            Cancelar
          </button>
        )}
      </>
    );

    return <form onSubmit={(e) => {
        e.preventDefault();
        formik.handleSubmit();
      }}
        id="AbaProfissionais_FormularioPesquisa"
      >
        {campoFiltroNomeProfissional}

        {!props.somenteLeitura && (
          <div className="_flex _gap-1 _my-4"
            id="AbaProfissionais_ContainerBotoesPesquisar"
          >
            {botaoPesquisarProfissionais}
            {botaoCancelarListaProfissionais}
            {botaoOkListaProfissionais}
          </div>
        )}
    </form>
  }

  const tabela = () => {
    const cabecalhoListaProfissionais = (
      <div className="_table-header-group "
        id="AbaProfissionais_CabecalhoTabela"
      >
        <div className="_table-row"
          id="AbaProfissionais_LinhaCabecalhoTabela"
        >
          <div
            className={`_table-cell _font-bold _px-2 _shadow-[1px_1px_rgb(255_255_255/50%)_inset] _bg-[#daddde] _border _border-[#c5cacb]`}
            id="AbaProfissionais_CabecalhoCodigo"
          >
            Código
          </div>
          <div
            className={`_table-cell _font-bold _px-2 _shadow-[1px_1px_rgb(255_255_255/50%)_inset] _bg-[#daddde] _border _border-[#c5cacb]`}
            id="AbaProfissionais_CabecalhoNome"
          >
            Nome
          </div>
          <div
            className={`_table-cell _font-bold _px-2 _shadow-[1px_1px_rgb(255_255_255/50%)_inset] _bg-[#daddde] _border _border-[#c5cacb]`}
            id="AbaProfissionais_CabecalhoTipo"
          >
            Tipo
          </div>
        </div>
      </div>
    );
  
    const dadosListaProfissionais = (
      <div className="_table-row-group">
        {props.listaPesquisa?.Entities?.map((value) => (
          <div
            key={value.Codigo}
            id={`AbaProfissionais_Linha${value.Codigo}`}
            className={`_table-row _cursor-pointer hover:_bg-white`}
            style={
              profissionaisSelecionados.some((p) => p.Codigo == value.Codigo)
                ? {
                    backgroundColor: props.colorBackgroundSelecionada,
                    color: props.colorTextoSelecionada,
                  }
                : {}
            }
          >
            <div
              className={`_table-cell _px-2 _shadow-[1px_1px_rgb(255_255_255/50%)_inset] _border _border-[#c5cacb]`}
              id={`AbaProfissionais_CelulaCodigo${value.Codigo}`}
              onClick={() => toggleProfissionaisSelecionada(value)}
            >
              {value.Codigo}
            </div>
            <div
              className={`_table-cell _px-2 _shadow-[1px_1px_rgb(255_255_255/50%)_inset] _border _border-[#c5cacb]`}
              id={`AbaProfissionais_CelulaNome${value.Codigo}`}
              onClick={() => toggleProfissionaisSelecionada(value)}
            >
              {value.Nome}
            </div>
            <div
              className={`_table-cell _px-2 _shadow-[1px_1px_rgb(255_255_255/50%)_inset] _border _border-[#c5cacb]`}
              id={`AbaProfissionais_CelulaTipo${value.Codigo}`}
            >
              <select
                name="Externo"
                multiple={false}
                id={`AbaProfissionais_SelectTipo${value.Codigo}`}
                disabled={props.somenteLeitura}
                value={(listaProfissionaisTipo[value.Codigo]) ?? ""}
                onChange={(e) => {
                  const valor =
                    e.target.value == "Externo"
                      ? "Externo"
                      : e.target.value == "Interno"
                      ? "Interno"
                      : "";
                  const novaListaProfissionaisTipo = {
                    ...listaProfissionaisTipo,
                  };
                  novaListaProfissionaisTipo[value.Codigo] = valor;
                  setListaProfissionaisTipo(novaListaProfissionaisTipo);
                }}
              >
                <option value="">
                  Selecione
                </option>
                <option value="Interno"
                  id={`AbaProfissionais_SelectTipo${value.Codigo}_Interno`}
                >Interno</option>
                <option value="Externo"
                  id={`AbaProfissionais_SelectTipo${value.Codigo}_Externo`}
                >Externo</option>
              </select>
            </div>
          </div>
        ))}
      </div>
    );

    const paginacaoListaProfissionais = (
      <>
        {props.listaPesquisa?.PageCount > 0 && (
          <div className="_pt-2 _my-2">
            <Paginacao
              key={props.abaProfissionaisFormulario.NumeroPagina}
              paginaAtual={props.abaProfissionaisFormulario.NumeroPagina}
              totalPaginas={props.listaPesquisa.PageCount}
              id="Profissionais_Paginacao"
              onAlterarListaSelecionada={(numeroPagina) => {props.onPesquisar({...formik.values, NumeroPagina: numeroPagina})}}
            />
          </div>
        )}
      </>
    );

    return props.listaPesquisa?.Entities?.length > 0 && (
      <>
        <div
          id="AbaProfissionais_ContainerTabela"
        >
          <div className="_table _w-full _border-collapse">
            {cabecalhoListaProfissionais}
            {dadosListaProfissionais}
          </div>

          <div
            id="AbaProfissionais_ContainerPaginacao"
          >
            {paginacaoListaProfissionais}
            {botaoOkListaProfissionais}
          </div>
        </div>
      </>
    )
  }

  return (
    <>
      {formPesquisa()}

      {tabela()}
      {<section style={{ marginBottom: "100px" }} />}
    </>
  );
};
